import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ShieldAlert, X } from "lucide-react";

/** Aviso preventivo en la caja: el certificado digital vence esta semana (o ya venció).
 *  Solo informa: la venta nunca se bloquea. */
export const CertificadoAvisoCaja = () => {
  const [info, setInfo] = useState(null);
  const [oculto, setOculto] = useState(false);

  useEffect(() => {
    let vivo = true;
    api.get("/sii/cert-aviso-caja", { silent402: true })
      .then((r) => { if (vivo && r.data?.aviso) setInfo(r.data); })
      .catch(() => {});
    return () => { vivo = false; };
  }, []);

  if (!info || oculto) return null;
  const vencido = info.estado === "VENCIDO";

  return (
    <div
      data-testid="pos-cert-alert-banner"
      className={`px-4 py-2 flex items-center gap-3 text-white print:hidden ${vencido ? "bg-rose-700" : "bg-rose-600"}`}
    >
      <ShieldAlert className="w-5 h-5 shrink-0 animate-pulse" />
      <div className="min-w-0 flex-1 leading-tight">
        <p className="text-sm font-extrabold">
          {vencido
            ? `Certificado digital VENCIDO el ${info.vence_el}`
            : `El certificado digital vence el ${info.vence_el} · quedan ${info.dias_restantes} día(s)`}
        </p>
        <p className="text-[11px] text-rose-50">
          {vencido
            ? "No se podrán emitir boletas ni facturas electrónicas. Renuévalo con tu entidad certificadora y súbelo en Configuración SII."
            : "Renuévalo antes del vencimiento para no quedar sin boleta electrónica."}
          {info.titular ? ` · Titular: ${info.titular}` : ""}
        </p>
      </div>
      <button
        data-testid="pos-cert-alert-close"
        onClick={() => setOculto(true)}
        className="shrink-0 p-1.5 rounded-full hover:bg-white/20"
        title="Ocultar por ahora"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default CertificadoAvisoCaja;
